import { Link } from "react-router-dom";
import { BUSINESS } from "@/lib/site";

export const Footer = () => (
  <footer className="bg-slate-950 border-t border-slate-800 text-slate-400 py-12 text-xs" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
        <div className="md:col-span-2">
          <span className="text-white font-bold text-base block mb-2">{BUSINESS.name}</span>
          <p className="text-xs text-slate-400 max-w-sm leading-relaxed">
            Electronics shopping and retail destination offering mobiles, home appliances, kitchen gadgets, and bulk
            commercial orders with verified GST bills and genuine warranty.
          </p>
          <p className="mt-4 text-slate-500">
            Phone / WhatsApp:{" "}
            <a href={`tel:${BUSINESS.phoneIntl}`} data-testid="footer-phone-link" className="hover:text-blue-400 transition-colors">
              {BUSINESS.phoneDisplay}
            </a>
            <br />
            Email:{" "}
            <a href={`mailto:${BUSINESS.email}`} data-testid="footer-email-link" className="hover:text-blue-400 transition-colors">
              {BUSINESS.email}
            </a>
          </p>
        </div>

        <div>
          <h4 className="text-white font-bold uppercase tracking-wider mb-3 text-xs">Store Sections</h4>
          <ul className="space-y-2">
            <li><Link to="/products" data-testid="footer-products-link" className="hover:text-blue-400 transition-colors">Products</Link></li>
            <li><Link to="/#features" data-testid="footer-advantage-link" className="hover:text-blue-400 transition-colors">Our Advantage</Link></li>
            <li><Link to="/#services" data-testid="footer-bulk-link" className="hover:text-blue-400 transition-colors">Bulk Supply</Link></li>
            <li><Link to="/#faq" data-testid="footer-faq-link" className="hover:text-blue-400 transition-colors">FAQ</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold uppercase tracking-wider mb-3 text-xs">Site Links</h4>
          <ul className="space-y-2">
            <li><Link to="/" data-testid="footer-home-link" className="hover:text-blue-400 transition-colors">Home (Front)</Link></li>
            <li><Link to="/about" data-testid="footer-about-link" className="hover:text-blue-400 transition-colors">About Us</Link></li>
            <li><Link to="/contact" data-testid="footer-contact-link" className="hover:text-blue-400 transition-colors">Contact Us</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-blue-400 transition-colors">Privacy Policy</Link></li>
            <li><Link to="/disclaimer" data-testid="footer-disclaimer-link" className="hover:text-blue-400 transition-colors">Disclaimer</Link></li>
            <li><Link to="/admin" data-testid="footer-admin-link" className="hover:text-blue-400 transition-colors">Owner Login</Link></li>
          </ul>
        </div>
      </div>

      <div className="pt-8 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between text-slate-500">
        <p>{BUSINESS.name}. Retail &amp; Shopping Electronics.</p>
        <p className="mt-2 sm:mt-0">Authentic Warranty &amp; GST Invoicing</p>
      </div>
    </div>
  </footer>
);
